export const QUESTION_TIME = 30;
